export const manifest = {
  screens: {
    scr_4hiihr: { name: "All You Need Is Love", route: "/", state: {"slide":0}, position: {"x":39360,"y":220} },
    scr_h7r0vq: { name: "Snak Agency of Record", route: "/", state: {"slide":1}, position: {"x":37960,"y":220} },
    scr_mabatu: { name: "Three Priorities Across the Product Lifecycle", route: "/", state: {"slide":2}, position: {"x":25360,"y":220} },
    scr_xx25ix: { name: "As Familiarity Grows, Format Shortens", route: "/", state: {"slide":3}, position: {"x":26760,"y":220} },
    scr_b2ks1n: { name: "HCPs Don’t Lack Content. They Lack Time.", route: "/", state: {"slide":4}, position: {"x":29560,"y":220} },
    scr_via2rw: { name: "Snaks Throughout the Customer Journey", route: "/", state: {"slide":5}, position: {"x":35160,"y":220} },
    scr_7yzgqg: { name: "Banner to Snak to Insight", route: "/", state: {"slide":6}, position: {"x":42160,"y":220} },
    scr_dt8odi: { name: "Built for Continued Campaigns", route: "/", state: {"slide":7}, position: {"x":30960,"y":220} },
    scr_aqx7nl: { name: "More Channels to Share", route: "/", state: {"slide":8}, position: {"x":2960,"y":220} },
    scr_tosm62: { name: "Suggested Further Master Snaks", route: "/", state: {"slide":9}, position: {"x":33760,"y":220} },
    scr_xex0ti: { name: "One Governance View", route: "/", state: {"slide":10}, position: {"x":32360,"y":220} },
    scr_udxev9: { name: "By Country and by Brand", route: "/", state: {"slide":11}, position: {"x":44960,"y":220} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 47720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_kp0esk" },
      { kind: "screen", id: "scr_aqx7nl" },
      { kind: "screen", id: "scr_qpa782" },
      { kind: "screen", id: "scr_mabatu" },
      { kind: "screen", id: "scr_xx25ix" },
      { kind: "screen", id: "scr_b2ks1n" },
      { kind: "screen", id: "scr_dt8odi" },
      { kind: "screen", id: "scr_xex0ti" },
      { kind: "screen", id: "scr_tosm62" },
      { kind: "screen", id: "scr_via2rw" },
      { kind: "screen", id: "scr_kfzndm" },
      { kind: "screen", id: "scr_h7r0vq" },
      { kind: "screen", id: "scr_4hiihr" },
      { kind: "screen", id: "scr_eqdlty" },
      { kind: "screen", id: "scr_7yzgqg" },
      { kind: "screen", id: "scr_hurztp" },
      { kind: "screen", id: "scr_udxev9" },
      { kind: "screen", id: "scr_5xhrky" },
    ] },
  ],
}
